import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './UnusualVolume.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function UnusualVolume(props) {
    const [data, setData] = useState([]);
    let optionInfoMarket = "Unusual Volume";
    let optionTypeComp = "Daily Market Tracker";
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    // const [valueLi, setValueLi] = useState("10");
    // const [valueLL, setValueLL] = useState("u");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [valuebtn, setValueBtn] = useState("U");
    const [valueLy, setValueLy] = useState("-");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        if (groupValue === "BSE") {
            const getUrl = BaseURL + "UnusualVolume";

            fetch(`${getUrl}/${groupValue}/${valuebtn}/${valueLy}/${groupIndex}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "UnusualVolume";
            fetch(`${getUrl}/${groupValue}/${valuebtn}//${valueLy}/${groupIndexNSE}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, valueLy, groupIndex, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Unusual Volume",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Unusual Volume</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Unusual Volume</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            {/* <div className='unusual-table-main'>
                                <div className='unusual-loser-toggle'>
                                    <button id="btnGain" value="gain" className={(valuebtn === "gain") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Gainers</button>
                                    <button id="btnLoose" value="lose" className={(valuebtn === "lose") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Losers</button>
                                </div> */}
                            <div className='gainer-table-main'>
                                <div className="unusualselectdiv">
                                    <div className='unusual-inner-select'>
                                        
                                        {/* aria-label="Up And Down" */}
                                        <select aria-label="Up And Down" onChange={(event) => { setValueBtn(event.target.value); }}>
                                            <option value="U" selected>Up</option>
                                            <option value="D" >Down</option>
                                        </select>
                                    </div>


                                    <div className='unusual-inner-select_I'>
                                        
                                        {/* aria-label="nse bse" */}
                                        <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>
                                    <div className='unusual-inner-selectIndex'>
                                        {(groupValue === "BSE") ?
                                            <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div>
                                </div>

                                {/* <hr className="hrUnusual"></hr> */}
                                <div className='unusual-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='padbottom30' rowspan="2">Company Name</th>
                                                <th className='text-right'>LTP(&#8377;)</th>


                                                <th className='text-right' >Volume(Nos.)</th>

                                                <th className='text-right'>Previous Price(&#8377;)</th>
                                                <th className='text-right'>Change(%)</th>
                                                <th className='text-right'>Volume Change(%)</th>

                                            </tr>

                                        </thead>
                                        {(groupValue === "BSE") ?
                                            <tbody>
                                                {currentTableData && currentTableData.map(
                                                    ({ lname, price, Volume, PrevPrice, PricePerChange, VolumePerChange, co_code }) => (
                                                        <tr>
                                                            <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + co_code} tabIndex={0} >{lname}</h6></td>
                                                            <td className="text-right"> {(price != null) ? price.toFixed(2) : 0}</td>
                                                            <td className="text-right"> {(Volume != null) ? Volume.toFixed(2) : 0}</td>
                                                            <td className="text-right"> {(PrevPrice != null) ? PrevPrice.toFixed(2) : 0}</td>
                                                            <td className={(PricePerChange > 0) ? "textGreen text-right" : "textRed text-right"}> {(PricePerChange != null) ? PricePerChange.toFixed(2) : 0}</td>
                                                            <td className={(VolumePerChange > 0) ? "textGreen text-right" : "textRed text-right"}> {(VolumePerChange != null) ? VolumePerChange.toFixed(2) : 0}</td>

                                                        </tr>
                                                    ))}
                                            </tbody> : <tbody>
                                                {currentTableData && currentTableData.map(
                                                    ({ lname, Price, Volume, PrevPrice, PricePerChange, VolumePerChange, co_code }) => (
                                                        <tr>
                                                            <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6></td>
                                                            <td className="text-right"> {(Price != null) ? Price.toFixed(2) : 0}</td>
                                                            <td className="text-right"> {(Volume != null) ? Volume.toFixed(2) : 0}</td>
                                                            <td className="text-right"> {(PrevPrice != null) ? PrevPrice.toFixed(2) : 0}</td>
                                                            <td className={(PricePerChange > 0) ? "textGreen text-right" : "textRed text-right"}> {(PricePerChange != null) ? PricePerChange.toFixed(2) : 0}</td>
                                                            <td className={(VolumePerChange > 0) ? "textGreen text-right" : "textRed text-right"}> {(VolumePerChange != null) ? VolumePerChange.toFixed(2) : 0}</td>

                                                        </tr>
                                                    ))}
                                            </tbody>}
                                    </table>

                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default UnusualVolume;